import axios from "axios";
import Swal from "sweetalert2";

// Apunta al backend Economías Colaborativas (mismo que RedJoven / Fenagro APL)
// Desarrollo: http://localhost:5246  |  Producción: ver .env
axios.defaults.baseURL = process.env.REACT_APP_URL_BASE || 'http://localhost:5246';

// Interceptor para manejar errores de red
axios.interceptors.response.use(
    response => response,
    error => {
        if (!error.response) {
            console.error('Error de red:', error.message);
            setTimeout(() => {
                Swal.fire({
                    title: 'Servidor no disponible',
                    text: 'No se pudo conectar al servidor. Contacte al servicio técnico.',
                    icon: 'error',
                });
            }, 100);
        } else {
            console.error('Error en la respuesta del servidor:', error.message);
        }
        return Promise.reject(new Error('Error personalizado: Algo salió mal'));
    }
);

const requestGenerico = {
    get:    (url)        => axios.get(url),
    post:   (url, body)  => axios.post(url, body),
    put:    (url, body)  => axios.put(url, body),
    delete: (url)        => axios.delete(url),
};

export default requestGenerico;
